import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useModal from 'components/Modals/useModal';
import { ModalBody, StyledBasicModal } from './styles';
import Button from 'components/Button';

export const EXPIRED_MODAL_TYPES = {
  SECURITY: 'security',
  INACTIVITY: 'inactivity',
};

export const ExpiredModal = ({
  type,
  handleSubmit,
  handleCancel,
  onHide,
  loading,
  logOut,
  remaining,
}) => {
  const { t } = useTranslation();
  const [modalProps, , { hide: hideModal }] = useModal({
    handleSubmit,
    handleHide: () => {},
    initialValue: true,
  });

  const modalAdditionalProps = useMemo(() => {
    const map = {
      [EXPIRED_MODAL_TYPES.INACTIVITY]: {
        heading: t('Inactivity Session Time Out'),
        defaultLeftBtnText: t('Log Out Now'),
        defaultLeftBtnHandler: () => logOut(null),
        leftBtn: <Button color="blue" />,
        buttonText: t('Extend Session'),
        bodyText: t(
          `Your session is expiring due to inactivity. You will be logged out at the time below if you don't take action`
        ),
      },
      [EXPIRED_MODAL_TYPES.SECURITY]: {
        heading: t('Security Session Time Out'),
        buttonText: t('Log Out Now'),
        defaultLeftBtnText: t('Close'),
        actionBtnColor: 'blue',
        bodyText: t(
          `Your session is expiring due to security. You will be logged out at the time below`
        ),
      },
    };
    return map[type] || map[EXPIRED_MODAL_TYPES.SECURITY];
  }, [type, t, logOut]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (remaining === 0) {
        clearInterval(interval);
        if (type === EXPIRED_MODAL_TYPES.INACTIVITY) {
          handleCancel();
        } else {
          logOut();
        }
        hideModal();
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [type, handleCancel, hideModal, logOut, remaining]);

  return (
    <StyledBasicModal
      diffPaddings={type === EXPIRED_MODAL_TYPES.INACTIVITY}
      {...modalProps}
      {...modalAdditionalProps}
      onHide={onHide}
      loading={loading}
    >
      <ModalBody>
        <div className="text"> {modalAdditionalProps.bodyText}:</div>
        <div className="timer">
          {remaining >= 0 ? <>{Math.floor(remaining / 1000)} s</> : null}
        </div>
      </ModalBody>
    </StyledBasicModal>
  );
};
